import { observer } from 'mobx-react-lite';
import { DATA } from '../../game/data';
import { COLORS } from '../../game/data/colors';
import { IMAGES } from '../../game/data/images';
import { BigButton } from '../UI/Reusable/BigButton';

export const AdvanceButton: React.FC = observer(() => {
  return (
    <BigButton
      onClick={() => {
        DATA.setOpenPopup('advance');
      }}
    >
      <img src={IMAGES.advance} alt={'img'} />
      ADVANCE
      {DATA.canAdvance && (
        <div
          style={{ position: 'absolute', padding: '2px 4px', backgroundColor: COLORS.green_500, borderRadius: 4, top: 'calc(100% + 4px)' }}
        >
          READY
        </div>
      )}
    </BigButton>
  );
});
